<template>
  <v-main style="min-height: 70vh">
    <v-container class="responsive-template-content">
      <v-row dense>
        <v-col cols="12">
          <v-card
            color="white"
            dark
            elevation="24"
            class="rounded-xl"
            style="padding: 2em"
          >
            <v-card-title
              class="font-weight-lighter"
              style="justify-content: center; color: grey"
              v-if="currentJobOffer !== null"
            >
              Consulter les candidatures au poste de : <br />
              {{ currentJobOffer.job.name }} - {{ currentJobOffer.type.name }}
            </v-card-title>
            <v-card-text></v-card-text>
            <v-row dense>
              <v-col cols="12" md="3">
                <v-btn
                  elevation="24"
                  small
                  rounded
                  color="primary"
                  to="/company/offers"
                >
                  <v-icon left> mdi-arrow-left-thin</v-icon>
                  Revenir à la liste de mes offres
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-container fluid>
                  <v-row justify="center">
                    <v-subheader>Today</v-subheader>

                    <v-expansion-panels
                      popout
                      light
                      v-if="currentJobOffer !== null"
                    >
                      <v-expansion-panel
                        v-for="(application, i) in currentJobOffer.applications"
                        :key="i"
                        hide-actions
                      >
                        <v-expansion-panel-header>
                          <v-row align="center" class="spacer" no-gutters>
                            <v-col cols="4" sm="2" md="1">
                              <v-avatar size="46px">
                                <img
                                  alt="Avatar"
                                  :src="getApplicantAvatar(application)"
                                />
                              </v-avatar>
                            </v-col>

                            <v-col class="hidden-xs-only" sm="5" md="3">
                              <strong
                                v-text="
                                  `${application.seeker.account.firstname} ${application.seeker.account.lastname}`
                                "
                              ></strong>
                            </v-col>
                            <v-col class="text-no-wrap" cols="5" sm="3">
                              <a
                                v-if="getCvLink(application.seeker.cv) !== '#'"
                                :href="getCvLink(application.seeker.cv)"
                                target="_blank"
                              >
                                <strong>Consulter le CV</strong>
                              </a>
                              <br />
                              <br />
                              <br />
                              <a
                                :href="`/company/cv-theque?loadSeeker=${application.seeker.id}`"
                                target="_blank"
                              >
                                <strong
                                  >Consulter le profil dans la CVtèque</strong
                                >
                              </a>
                            </v-col>
                            <v-col
                              class="grey--text text-truncate hidden-sm-and-down"
                              v-html="
                                application.coverLetter.substr(0, 40) + '...'
                              "
                            >
                            </v-col>
                          </v-row>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-divider></v-divider>
                          <v-card-text v-html="application.coverLetter">
                          </v-card-text>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import HttpClient from "@/services/HttpClient/HttpClient";
import Vue from "vue";

export default Vue.extend({
  name: "CompanyViewApplications",
  components: {},
  data: function () {
    return {
      companyInfosIsUpdated: false,
      currentYear: "" + new Date().getFullYear(),
      currentUser: null,
      companyActivitySector: null,
      companyInformations: null,
      currentJobOffer: null,
    };
  },
  created() {
    const httpClient = new HttpClient();

    httpClient
      .fetchFromApiPlatformUri(
        "/api/job_offers/" +
          parseInt(this.$route.params.offerId) +
          "?filter[isDeleted]=false",
        localStorage.getItem("jwt-token")
      )
      .then((value) => {
        this.currentJobOffer = value.data;
      })
      .catch((reason) => {
        if (reason.response.status === 401) {
          this.$router.push("/logout");
        } else if (
          reason.response.status === 404 ||
          reason.response.status === 403
        ) {
          this.$router.push({
            name: "not_found",
          });
        }
        this.formErrors.push(reason);
        console.error(reason);
      });
  },
  methods: {
    getCvLink(cv) {
      if (cv && "fileName" in cv) {
        return `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/uploads/cv/${cv.fileName}`;
      } else {
        return "#";
      }
    },

    getApplicantAvatar(application) {
      if (application.seeker.account.userAvatar !== null) {
        return `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/uploads/avatar/${application.seeker.account.userAvatar.fileName}`;
      }

      return "https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg?w=1380&t=st=1676581960~exp=1676582560~hmac=9ffcc77113c06c6f414580acff2c4cbe119a2ffe331a8801d5c936bc4d55c59f";
    },
  },
});
</script>

<style scoped></style>
